<app-funnel-shell>
  <div class="funnel-card join">

    @switch (screen()) {

      <!-- 1 — THE HOOK -->
      @case (1) {
        <h1>{{ 'funnel.join.hook.title' | translate }}</h1>
        <p class="join__lead">{{ 'funnel.join.hook.line1' | translate }}</p>
        <p class="join__lead">{{ 'funnel.join.hook.line2' | translate }}</p>
        <p class="join__lead">{{ 'funnel.join.hook.line3' | translate }}</p>
        <p class="join__price">{{ 'funnel.join.price_week' | translate }}</p>
      }

      <!-- 2 — WHAT DO I GET? -->
      @case (2) {
        <h1>{{ 'funnel.join.benefits.title' | translate }}</h1>
        <p class="join__lead">{{ 'funnel.join.benefits.subtitle' | translate }}</p>

        <ul class="join__benefits">
          <li>
            <span class="join__benefit-title">🧬 {{ 'funnel.join.benefits.knowledge_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.benefits.knowledge_text' | translate }}</span>
          </li>
          <li>
            <span class="join__benefit-title">💬 {{ 'funnel.join.benefits.concierge_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.benefits.concierge_text' | translate }}</span>
          </li>
          <li>
            <span class="join__benefit-title">🌎 {{ 'funnel.join.benefits.health_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.benefits.health_text' | translate }}</span>
          </li>
          <li>
            <span class="join__benefit-title">🐺 {{ 'funnel.join.benefits.pool_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.benefits.pool_text' | translate }}</span>
          </li>
        </ul>

        <p class="funnel-card__footnote">{{ 'funnel.join.benefits.footnote' | translate }}</p>
        <p class="join__price">{{ 'funnel.join.benefits.all_for' | translate }}</p>
      }

      <!-- 3 — WHAT HAPPENS WHEN I SHARE IT? -->
      @case (3) {
        <h1>{{ 'funnel.join.share.title' | translate }}</h1>
        <p class="join__lead">{{ 'funnel.join.share.subtitle' | translate }}</p>

        <ul class="join__benefits">
          <li>
            <span class="join__benefit-title">💵 {{ 'funnel.join.share.direct_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.share.direct_text' | translate }}</span>
          </li>
          <li>
            <span class="join__benefit-title">♾️ {{ 'funnel.join.share.depth_title' | translate }}</span>
            <span class="join__benefit-text">{{ 'funnel.join.share.depth_text' | translate }}</span>
          </li>
        </ul>

        <ol class="join__chain">
          <li>{{ 'funnel.join.share.chain_you' | translate }}</li>
          <li>{{ 'funnel.join.share.chain_first_line' | translate }}</li>
          <li>{{ 'funnel.join.share.chain_their_line' | translate }}</li>
          <li class="join__chain-infinite">∞</li>
        </ol>
        <p class="join__emphasis">{{ 'funnel.join.share.no_depth_limit' | translate }}</p>

        <p class="join__lead">{{ 'funnel.join.share.pool_text' | translate }}</p>
        <p class="join__emphasis">{{ 'funnel.join.share.closing' | translate }}</p>
      }

      <!-- 4 — KEEP IT SIMPLE -->
      @case (4) {
        <h1>{{ 'funnel.join.simple.title' | translate }}</h1>

        <ul class="join__nots">
          <li>{{ 'funnel.join.simple.no_trading' | translate }}</li>
          <li>{{ 'funnel.join.simple.no_staking' | translate }}</li>
          <li>{{ 'funnel.join.simple.no_locking' | translate }}</li>
          <li>{{ 'funnel.join.simple.no_freezing' | translate }}</li>
          <li>{{ 'funnel.join.simple.no_return_promises' | translate }}</li>
          <li>{{ 'funnel.join.simple.no_comp_plan' | translate }}</li>
        </ul>

        <p class="join__lead">{{ 'funnel.join.simple.text' | translate }}</p>
        <p class="join__emphasis">{{ 'funnel.join.simple.closing' | translate }}</p>
      }

      <!-- 5 — ONE SIMPLE DECISION -->
      @case (5) {
        <h1>{{ 'funnel.join.decision.title' | translate }}</h1>
        <p class="join__price">{{ 'funnel.join.price_week' | translate }}</p>
        <p class="join__lead">{{ 'funnel.join.decision.subtitle' | translate }}</p>

        <div class="join__prepay">
          <p class="join__lead">{{ 'funnel.join.decision.plan_ahead' | translate }}</p>
          <p class="join__emphasis">{{ 'funnel.join.decision.prepay_weeks' | translate }}</p>
          <p class="join__lead">{{ 'funnel.join.decision.or' | translate }}</p>
          <p class="join__price">{{ 'funnel.join.price_year' | translate }}</p>
          <p class="funnel-card__footnote">{{ 'funnel.join.decision.saving' | translate }}</p>
        </div>

        <p class="join__emphasis">{{ 'funnel.join.decision.closing' | translate }}</p>
      }

      <!-- 6 — SIGNUP -->
      @case (6) {
        <h1>{{ 'funnel.join.signup.title' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'funnel.join.signup.subtitle' | translate }}</p>
        @if (intent.plan) {
          <!-- Website V2: name what was chosen on the site, so the visitor sees the
               choice survived the hop into the app. -->
          <p class="join__emphasis">{{ ('funnel.intent.chosen.' + intent.plan) | translate:{ weeks: intent.weeks ?? '' } }}</p>
        }

        <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
            <input
              cFormControl
              formControlName="first_name"
              type="text"
              [placeholder]="'funnel.landing.first_name_placeholder' | translate"
              [class.is-invalid]="firstNameCtrl().touched && firstNameCtrl().invalid"
              unassistedInput
            />
            @if (firstNameCtrl().touched && firstNameCtrl().invalid) {
              <c-form-feedback [valid]="false">
                {{ 'funnel.landing.first_name_required' | translate }}
              </c-form-feedback>
            }
          </c-input-group>

          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
            <input
              cFormControl
              formControlName="last_name"
              type="text"
              [placeholder]="'funnel.landing.last_name_placeholder' | translate"
              unassistedInput
            />
          </c-input-group>

          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilEnvelopeClosed"></svg></span>
            <input
              cFormControl
              formControlName="email"
              type="email"
              [placeholder]="'funnel.landing.email_placeholder' | translate"
              [class.is-invalid]="emailCtrl().touched && emailCtrl().invalid"
              unassistedInput
            />
            @if (emailCtrl().touched && emailCtrl().invalid) {
              <c-form-feedback [valid]="false">
                @if (emailCtrl().errors?.['required']) {
                  {{ 'funnel.landing.email_required' | translate }}
                }
                @if (emailCtrl().errors?.['email']) {
                  {{ 'funnel.landing.email_invalid' | translate }}
                }
              </c-form-feedback>
            }
          </c-input-group>

          <div class="mb-3">
            <div id="mcaptcha-widget"></div>
            @if (captchaError()) {
              <small class="text-danger">{{ 'funnel.landing.captcha_required' | translate }}</small>
            }
          </div>

          <button cButton color="primary" type="submit" class="w-100" [disabled]="!canSubmit()">
            @if (loading()) {
              {{ 'funnel.landing.submitting' | translate }}
            } @else {
              {{ 'funnel.join.signup.submit' | translate }}
            }
          </button>

          @if (error()) {
            <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
          }
        </form>
      }
    }

    <!-- CTA row — every marketing screen offers both "keep reading" and "join now" -->
    @if (!onSignup()) {
      <div class="join__actions">
        <button cButton color="primary" class="w-100" type="button" (click)="join()">
          {{ 'funnel.join.cta_join' | translate }}
        </button>
        @if (screen() < lastContentScreen) {
          <button cButton color="secondary" variant="outline" class="w-100" type="button" (click)="next()">
            {{ 'funnel.join.cta_next' | translate }}
          </button>
        }
      </div>
    }

    @if (fromWebsite()) {
      <!-- Arrived from the website with a chosen entry: the five screens were
           skipped, so "back" means back to the site (a full page load — `/` is the
           static site, not an app route). -->
      <a class="join__back" href="/">{{ 'funnel.intent.back_to_website' | translate }}</a>
    } @else if (screen() > 1) {
      <button class="join__back" type="button" (click)="back()">
        {{ 'funnel.join.cta_back' | translate }}
      </button>
    }

    @if (sponsorId()) {
      <p class="funnel-card__footnote">
        {{ 'funnel.landing.referred_by' | translate }}: <strong>#{{ sponsorId() }}</strong>
      </p>
    }

    <!-- Screen counter: five screens, so the visitor can see how short this is. -->
    @if (!onSignup()) {
      <div class="join__dots" aria-hidden="true">
        @for (dot of [1, 2, 3, 4, 5]; track dot) {
          <span class="join__dot" [class.join__dot--on]="dot === screen()"></span>
        }
      </div>
    }
  </div>
</app-funnel-shell>
